import React from "react";
import { Tabs, PageHeader } from "antd";

import { Hability } from "./hability";
import { HabilityType } from "./habilityType";

const { TabPane } = Tabs;

export function HabilityPage() {
    return (
        <>
            <PageHeader title="Lista Habilidades" />
            <Tabs defaultActiveKey="1">
                <TabPane tab="Tipos de habilidade" key="1">
                    <HabilityType />
                </TabPane>
                <TabPane tab="Habilidades" key="2">
                    <Hability />
                </TabPane>
            </Tabs>
        </>
    );
}
